// Initialize accordions
function initFaqItems() {
    const faqItems = document.querySelectorAll(".js-faqitem");

    // Function to close an accordion
    const closeFaqItem = (faqItem) => {
        const content = faqItem.querySelector(".js-faqitem-content");
        const button = faqItem.querySelector("button");

        if (content && button) {
            content.style.height = "0px";
            faqItem.classList.remove("is-active");
            button.style.transform = "rotate(0deg)";
        }
    };
    
    // Function to close all accordions
    const closeAllFaqItems = () => {
        faqItems.forEach(closeFaqItem);
    };
    
    faqItems.forEach((faqItem) => {
        const heading = faqItem.querySelector(".js-faqitem-heading");
        const content = faqItem.querySelector(".js-faqitem-content");
        const button = heading.querySelector("button");
        
        if (!heading || !content || !button) return;
        
        heading.addEventListener("click", () => {
            const isOpen = content.style.height !== "0px";
            
            // Close all accordions first
            closeAllFaqItems();
            
            // If the clicked accordion was closed, open it
            if (!isOpen) {
                content.style.height = `${content.scrollHeight}px`;
                faqItem.classList.add("is-active");
                button.style.transform = "rotate(45deg)";
            }
        });
    });
}
  
// Initialize accordions when DOM is loaded
document.addEventListener('DOMContentLoaded', initFaqItems);

// Re-initialize accordions when sections are loaded
document.addEventListener('shopify:section:load', initFaqItems);